<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zh-Hant' || this.$route.query.lang == 'pt')
        localStorage.setItem('lan', this.$route.query.lang);
      this.$i18n.locale = this.$route.query.lang;
    } else {
      this.$i18n.locale = localStorage.getItem('lan')
        ? localStorage.getItem('lan')
        : 'zh-Hant';
    }
  },
  mounted() {
    window.onresize = () => {
      this.$store.commit('changeWidth', document.body.clientWidth);
      this.$store.commit('changeHeight', document.body.clientHeight);
    };
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Microsoft JhengHei',
    'PingFang TC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
